import React from "react";
import { useDocumentMeta } from "../components/useDocumentMeta";
import ResourceGate from "../components/ResourceGate";

const whitepaperTakeaways = [
  "Why adoption — not installation — is the real measure of an IDP",
  "The four-layered model for a consistent Developer Experience",
  "How inner source turns a platform team's project into the org's product",
  "Compliance by default: turning a periodic gate into a continuous signal",
  "A repeatable discovery method to find where work actually gets stuck",
];

function Resources() {
  useDocumentMeta(
    "Resources",
    "Download our whitepaper on building Internal Developer Platforms that developers actually adopt.",
  );

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <p className="kicker">Resources</p>
          <h1 className="page-title">Whitepaper: platforms that get adopted</h1>
          <p className="page-lead">
            What separates an IDP that developers reach for every day from one
            that becomes another tool on the shelf — distilled from years of
            building developer platforms across multiple clients.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container split-layout">
          <div className="split-content">
            <h2 className="section-title">What's inside</h2>
            <ul className="check-list">
              {whitepaperTakeaways.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>

          <aside className="split-aside">
            <div className="gate-card">
              <h2>Get the whitepaper</h2>
              <p className="cta-note">
                Tell us where to send it and we'll deliver your copy.
              </p>
              <ResourceGate downloadLabel="Download the whitepaper" />
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}

export default Resources;
